<ng-container *ngIf="regionState$ | async as state">
  <div class="mat-caption">
    {{ state.region?.description }}
  </div>
</ng-container>
